import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/blog": [~7,[2],[3]],
		"/blog/[slug]": [8,[2],[3]],
		"/demo": [9,[4]],
		"/demo/chats": [10,[4]],
		"/demo/files": [11,[4]],
		"/emergency": [12,[5]],
		"/emergency/chat": [13,[5]],
		"/emergency/drive": [14,[5]],
		"/emergency/login": [15,[5]],
		"/emergency/pake": [16,[5]],
		"/emergency/settings": [17,[5]],
		"/emergency/signup": [18,[5]],
		"/tools": [19],
		"/tools/identity-generator": [20],
		"/tools/password-generator": [21],
		"/vault/access": [22],
		"/vault/create": [23],
		"/vault/managed": [24],
		"/vault/passwordless": [25]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.js';